import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import GQLApplications from "./Applications.graphql";
import GQLUpsertApplication from "./UpsertApplication.graphql";
import Application, { ApplicationStruct } from "../../features/applications/domain/Application";

export default function useUpsertApplication(application: Application) {
    const { domain, ...app } = application;
    return useMutation<UpsertApplicationResult>(
        gql(GQLUpsertApplication),
        {
            refetchQueries: [
                gql(GQLApplications),
            ],
            variables: {
                application: app,
                domain,
            },
        },
    );
}

interface UpsertApplicationResult {
    upsertApplication: ApplicationStruct
}
